module.exports = __webpack_public_path__ + "static/media/sell_take_order_rent_4.e8f1b917.jpg";